var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserAddIcon = function SvgUserAddIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.75C7.20507 2.75 5.75 4.20507 5.75 6C5.75 7.79493 7.20507 9.25 9 9.25C10.7949 9.25 12.25 7.79493 12.25 6C12.25 4.20507 10.7949 2.75 9 2.75ZM4.25 6C4.25 3.37665 6.37665 1.25 9 1.25C11.6234 1.25 13.75 3.37665 13.75 6C13.75 8.62335 11.6234 10.75 9 10.75C6.37665 10.75 4.25 8.62335 4.25 6ZM1.25 18.8C1.25 15.7348 3.73482 13.25 6.8 13.25H11.2C14.2652 13.25 16.75 15.7348 16.75 18.8C16.75 20.9815 14.9815 22.75 12.8 22.75H5.2C3.01848 22.75 1.25 20.9815 1.25 18.8ZM6.8 14.75C4.56325 14.75 2.75 16.5632 2.75 18.8C2.75 20.1531 3.8469 21.25 5.2 21.25H12.8C14.1531 21.25 15.25 20.1531 15.25 18.8C15.25 16.5632 13.4368 14.75 11.2 14.75H6.8ZM20.75 7C20.75 6.58579 20.4142 6.25 20 6.25C19.5858 6.25 19.25 6.58579 19.25 7V9.25H17C16.5858 9.25 16.25 9.58579 16.25 10C16.25 10.4142 16.5858 10.75 17 10.75H19.25V13C19.25 13.4142 19.5858 13.75 20 13.75C20.4142 13.75 20.75 13.4142 20.75 13V10.75H23C23.4142 10.75 23.75 10.4142 23.75 10C23.75 9.58579 23.4142 9.25 23 9.25H20.75V7Z",
    fill: "#22272F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserAddIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-add-icon.e0c33fe1.svg";
export { ForwardRef as ReactComponent };